/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChangePassword200Response,
  ChangePasswordRequest,
  GetAccount200Response,
  GetAccountSettings200Response,
  GetAccountStatuses200Response,
  GetResetTokenSubstitute200Response,
  GetTokenSubstitute200Response,
  GetTokenSubstituteRequest,
  IssueCsrfToken400Response,
  RequestEmailChangeRequest,
  RequestPasswordChangeRequest,
  UpdateAccountRequest,
  UpdatePasswordRequest,
} from '../models/index';
import {
    ChangePassword200ResponseFromJSON,
    ChangePassword200ResponseToJSON,
    ChangePasswordRequestFromJSON,
    ChangePasswordRequestToJSON,
    GetAccount200ResponseFromJSON,
    GetAccount200ResponseToJSON,
    GetAccountSettings200ResponseFromJSON,
    GetAccountSettings200ResponseToJSON,
    GetAccountStatuses200ResponseFromJSON,
    GetAccountStatuses200ResponseToJSON,
    GetResetTokenSubstitute200ResponseFromJSON,
    GetResetTokenSubstitute200ResponseToJSON,
    GetTokenSubstitute200ResponseFromJSON,
    GetTokenSubstitute200ResponseToJSON,
    GetTokenSubstituteRequestFromJSON,
    GetTokenSubstituteRequestToJSON,
    IssueCsrfToken400ResponseFromJSON,
    IssueCsrfToken400ResponseToJSON,
    RequestEmailChangeRequestFromJSON,
    RequestEmailChangeRequestToJSON,
    RequestPasswordChangeRequestFromJSON,
    RequestPasswordChangeRequestToJSON,
    UpdateAccountRequestFromJSON,
    UpdateAccountRequestToJSON,
    UpdatePasswordRequestFromJSON,
    UpdatePasswordRequestToJSON,
} from '../models/index';

export interface ChangePasswordOperationRequest {
    changePasswordRequest?: ChangePasswordRequest;
}

export interface GetAccountSettingsRequest {
    settingCategory: string;
}

export interface GetTokenSubstituteOperationRequest {
    getTokenSubstituteRequest?: GetTokenSubstituteRequest;
}

export interface RequestEmailChangeOperationRequest {
    requestEmailChangeRequest?: RequestEmailChangeRequest;
}

export interface RequestPasswordChangeOperationRequest {
    xCSRFToken?: string;
    requestPasswordChangeRequest?: RequestPasswordChangeRequest;
}

export interface UpdateAccountOperationRequest {
    updateAccountRequest?: UpdateAccountRequest;
}

export interface UpdatePasswordOperationRequest {
    xPASSWORDToken?: string;
    updatePasswordRequest?: UpdatePasswordRequest;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * 現パスワードから新パスワードに変更します。
     * パスワード変更
     */
    async changePasswordRaw(requestParameters: ChangePasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangePassword200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/password/change`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestToJSON(requestParameters.changePasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangePassword200ResponseFromJSON(jsonValue));
    }

    /**
     * 現パスワードから新パスワードに変更します。
     * パスワード変更
     */
    async changePassword(requestParameters: ChangePasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangePassword200Response> {
        const response = await this.changePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 認証トークンからアカウント情報を取得します。
     * アカウント情報取得
     */
    async getAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * 認証トークンからアカウント情報を取得します。
     * アカウント情報取得
     */
    async getAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.getAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * アカウントの設定情報を取得します。  設定コード | 設定カテゴリー | 設定タイプ | 設定名            | 設定ステータス          | | ----------- | --------- | ---------------- | --------------------- | | 200         | 201       | 運営からのお知らせ  | 0:OFF、1:ON           |
     * アカウント設定取得
     */
    async getAccountSettingsRaw(requestParameters: GetAccountSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountSettings200Response>> {
        if (requestParameters.settingCategory === null || requestParameters.settingCategory === undefined) {
            throw new runtime.RequiredError('settingCategory','Required parameter requestParameters.settingCategory was null or undefined when calling getAccountSettings.');
        }

        const queryParameters: any = {};

        if (requestParameters.settingCategory !== undefined) {
            queryParameters['setting_category'] = requestParameters.settingCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * アカウントの設定情報を取得します。  設定コード | 設定カテゴリー | 設定タイプ | 設定名            | 設定ステータス          | | ----------- | --------- | ---------------- | --------------------- | | 200         | 201       | 運営からのお知らせ  | 0:OFF、1:ON           |
     * アカウント設定取得
     */
    async getAccountSettings(requestParameters: GetAccountSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountSettings200Response> {
        const response = await this.getAccountSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アカウントのステータス情報を取得します。
     * アカウントステータス取得
     */
    async getAccountStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountStatuses200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/statuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountStatuses200ResponseFromJSON(jsonValue));
    }

    /**
     * アカウントのステータス情報を取得します。
     * アカウントステータス取得
     */
    async getAccountStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountStatuses200Response> {
        const response = await this.getAccountStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 別企業代理を解除し新しいトークンを発行します。
     * 企業代理解除トークン取得
     */
    async getResetTokenSubstituteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetResetTokenSubstitute200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/substitute`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetResetTokenSubstitute200ResponseFromJSON(jsonValue));
    }

    /**
     * 別企業代理を解除し新しいトークンを発行します。
     * 企業代理解除トークン取得
     */
    async getResetTokenSubstitute(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetResetTokenSubstitute200Response> {
        const response = await this.getResetTokenSubstituteRaw(initOverrides);
        return await response.value();
    }

    /**
     * 別企業代理用のトークンを発行します。
     * 企業代理トークン取得
     */
    async getTokenSubstituteRaw(requestParameters: GetTokenSubstituteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTokenSubstitute200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/substitute`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetTokenSubstituteRequestToJSON(requestParameters.getTokenSubstituteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTokenSubstitute200ResponseFromJSON(jsonValue));
    }

    /**
     * 別企業代理用のトークンを発行します。
     * 企業代理トークン取得
     */
    async getTokenSubstitute(requestParameters: GetTokenSubstituteOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTokenSubstitute200Response> {
        const response = await this.getTokenSubstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メールアドレスの変更依頼受付。 SendGridサービスを利用して、メール変更トークン付きURLをメールで送信します。
     * メール変更依頼
     */
    async requestEmailChangeRaw(requestParameters: RequestEmailChangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken400Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/mail/request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestEmailChangeRequestToJSON(requestParameters.requestEmailChangeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken400ResponseFromJSON(jsonValue));
    }

    /**
     * メールアドレスの変更依頼受付。 SendGridサービスを利用して、メール変更トークン付きURLをメールで送信します。
     * メール変更依頼
     */
    async requestEmailChange(requestParameters: RequestEmailChangeOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken400Response> {
        const response = await this.requestEmailChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * パスワードの変更依頼受付。未ログインの場合に使用されます。 SendGridサービスを利用して、パスワード再発行トークン付きURLをメールで送信します。
     * パスワード変更依頼
     */
    async requestPasswordChangeRaw(requestParameters: RequestPasswordChangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken400Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xCSRFToken !== undefined && requestParameters.xCSRFToken !== null) {
            headerParameters['X-CSRF-Token'] = String(requestParameters.xCSRFToken);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/password/request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestPasswordChangeRequestToJSON(requestParameters.requestPasswordChangeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken400ResponseFromJSON(jsonValue));
    }

    /**
     * パスワードの変更依頼受付。未ログインの場合に使用されます。 SendGridサービスを利用して、パスワード再発行トークン付きURLをメールで送信します。
     * パスワード変更依頼
     */
    async requestPasswordChange(requestParameters: RequestPasswordChangeOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken400Response> {
        const response = await this.requestPasswordChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アカウント情報を更新します
     * アカウント情報更新
     */
    async updateAccountRaw(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken400Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountRequestToJSON(requestParameters.updateAccountRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken400ResponseFromJSON(jsonValue));
    }

    /**
     * アカウント情報を更新します
     * アカウント情報更新
     */
    async updateAccount(requestParameters: UpdateAccountOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken400Response> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * パスワード依頼のURLから遷移した場合にパスワード更新します。、SendGridサービスを利用して、変更完了をメールで送信します。
     * パスワード更新
     */
    async updatePasswordRaw(requestParameters: UpdatePasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken400Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xPASSWORDToken !== undefined && requestParameters.xPASSWORDToken !== null) {
            headerParameters['X-PASSWORD-Token'] = String(requestParameters.xPASSWORDToken);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/password/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePasswordRequestToJSON(requestParameters.updatePasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken400ResponseFromJSON(jsonValue));
    }

    /**
     * パスワード依頼のURLから遷移した場合にパスワード更新します。、SendGridサービスを利用して、変更完了をメールで送信します。
     * パスワード更新
     */
    async updatePassword(requestParameters: UpdatePasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken400Response> {
        const response = await this.updatePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
